import * as Pdf from "./Pdf";
export default Pdf;
